export const login = (value) => {
  if (value === undefined) return undefined
  return value?.length === 0 ? 'Preencha o email corretamente' : undefined
}

export function validateReceitaError(error, field, message) {
  // if (error) return `${field} não condiz com Receita Federal`
  if (error) return `${message}`
}

export const senha = (value) => {
  if (value?.length || 0) return undefined
  if ((value?.length || 0) < 6)
    return 'A senha deve conter entre 6 e 8 caracteres'
  if ((value?.length || 0) > 8)
    return 'A senha deve conter entre 6 e 8 caracteres'
  return undefined
}

export const cellVal = (value) => {
  if (value === undefined) return undefined
  return (value?.length || 0) < 15 ? 'Número de celular incompleto' : undefined
}

export const fixPhoneVal = (value) => {
  if (value === undefined) return undefined
  return (value?.length || 0) < 14 && (value?.length || 0) > 0
    ? 'Número de telefone incompleto'
    : undefined
}

export const contatoVal = (value) => {
  if (value === undefined) return undefined
  return (value?.length || 0) < 2 ? 'Preencher contato' : undefined
}

export const razaoVal = (value) => {
  if (value === undefined) return undefined
  return (value?.length || 0) < 2 ? 'Preencher razão social' : undefined
}

export const nomeFanVal = (value) => {
  if (value === undefined) return undefined
  return (value?.length || 0) < 2 ? 'Preencher nome fantasia' : undefined
}

function validarCNPJ(cnpj) {
  cnpj = cnpj?.replace(/[^\d]+/g, '')
  if (cnpj === '') return false
  if (cnpj.length !== 14) return false
  // Elimina CNPJs invalidos conhecidos
  if (
    cnpj === '00000000000000' ||
    cnpj === '11111111111111' ||
    cnpj === '22222222222222' ||
    cnpj === '33333333333333' ||
    cnpj === '44444444444444' ||
    cnpj === '55555555555555' ||
    cnpj === '66666666666666' ||
    cnpj === '77777777777777' ||
    cnpj === '88888888888888' ||
    cnpj === '99999999999999'
  )
    return false
  // Valida DVs
  let tamanho = cnpj.length - 2
  let numeros = cnpj.substring(0, tamanho)
  let digitos = cnpj.substring(tamanho)
  let soma = 0
  let pos = tamanho - 7
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--
    if (pos < 2) pos = 9
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
  // eslint-disable-next-line eqeqeq
  if (resultado != digitos.charAt(0)) return false

  tamanho = tamanho + 1
  numeros = cnpj.substring(0, tamanho)
  soma = 0
  pos = tamanho - 7
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--
    if (pos < 2) pos = 9
  }
  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
  // eslint-disable-next-line eqeqeq
  if (resultado != digitos.charAt(1)) return false
  return true
}

export const cnpjVal = (value) => {
  if (value === undefined) return undefined
  value = value?.replace(/[^\d]+/g, '')
  if ((value?.length || 0) < 14) return 'CNPJ deve ser composto de 14 dígitos'
  return validarCNPJ(value) ? undefined : 'CNPJ inválido'
}

export const inscEstVal = (value) => {
  if (value === undefined) return undefined
  return (value?.length || 0) < 8 && value !== 'ISENTO'
    ? 'Inscrição estadual possui no mínimo 8 digitos'
    : undefined
}

export const inscMunVal = (value) => {
  if (value === undefined) return undefined
  return (value?.length || 0) < 6 ? 'Preencher Inscrição Municipal' : undefined
}

export const openVal = (value) => {
  if (value === undefined) return undefined
  if ((value?.length || 0) < 10) return 'Data de abertura obrigatória'
  const dates = value?.split('/') || []
  if (+dates[0] < 1 || +dates[0] > 31)
    return 'O dia de abertura deve ser entre 01 e 31'
  if (+dates[1] < 1 || +dates[1] > 12)
    return 'O mês de abertura deve ser entre 01 e 12'
  if (+dates[2] < 1700) return 'Favor preencher com ano válido'
  return undefined
}

export const comercialPhoneVal = (value) => {
  if (value === undefined) return undefined
  return (value?.length || 0) < 14 ? 'Telefone Comercial incompleto' : undefined
}

export const fieldVal = (arr, val) => {
  let message = ''
  for (let i = 0; i < arr.length; i++) {
    if (val[i](arr[i])) message += val[i](arr[i]) + '. '
  }
  return message
}

export const selectVal = (value = -1) => {
  if (value === -1) return 'Selecionar campo obrigatório'
  return undefined
}
